document.addEventListener("teeinblue-event-component-injected", function () {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector(".best-fit-size-chart")) {
      const elementToMove = document.querySelector(".best-fit-size-chart");
      const insertAfterElement = document.querySelector(".tee-product-price");
      if (elementToMove && insertAfterElement) {
        insertAfterElement.after(elementToMove);
      }
      clearInterval(checkElementRendered);
    }
  }, 500);
});

document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});
